/**
 * User free chat usage - (Mirrored from cloud functions)
 */
export interface ChatSession {
  firstMessageId: string;
  startedAt: any; // Stored as Firestore Timestamp
}

export interface FreeChatUsage {
  chatsThisWeek: ChatSession[];
  weeklyResetTimestamp: any; // Stored as Firestore Timestamp
}

export interface QuestJourney {
  currentDay: number;
  isCurrentDayCompleted: boolean;
  createdAt: any; // Stored as Firestore Timestamp
  updatedAt: any; // Stored as Firestore Timestamp
}

export enum OnboardingProgress {
  EnteredReferralCode = 'entered_referral_code',
  RespondedToWhatBringsYouHere = 'responded_to_what_brings_you_here',
  DrawnHeart = 'drawn_heart',
  AnsweredOcdThemeQuestions = 'answered_ocd_theme_questions',
  GaveNotificationPermissions = 'gave_notification_permissions',
  GaveRating = 'gave_rating',
  FinishedOnboarding = 'finished_onboarding',
}

export interface ObsessLessUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  createdAt: Date;
  hasFinishedOnboarding: boolean;
  onboardingProgress: string;
  freeChatUsage?: FreeChatUsage;
  isProUser: boolean;
  referralCode?: string;
  questJourney?: QuestJourney;
}
